// extracted by mini-css-extract-plugin
module.exports = {"appointmentPage":"booking-page_appointmentPage__M7bl0","bookingView":"booking-page_bookingView__Lrspe","bookingViewInner":"booking-page_bookingViewInner__vhCUK"};